import type { Metadata } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const getInteractionModeExecutedFromMetadata = (
	metadata?: Pick<Metadata, 'interaction_mode_executed'> | null,
): string | undefined => metadata?.interaction_mode_executed ?? undefined;
